import React from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    open: {
        backgroundColor: 'rgba(229, 57, 53, 0.15)',
        color: theme.palette.error.main,
        fontWeight: 500,
        fontSize: 11
    },
    completed: {
        backgroundColor: 'rgba(76, 175, 80, 0.15)',
        color: theme.palette.success.main,
        fontWeight: 500,
        fontSize: 11
    },
    pending: {
        backgroundColor: 'rgba(255, 152, 0, 0.15)',
        color: theme.palette.warning.main,
        fontWeight: 500,
        fontSize: 11
    },
    running: {
        backgroundColor: 'rgba(33, 150, 243, 0.15)',
        color: theme.palette.info.main,
        fontWeight: 500,
        fontSize: 11
    },
    active: {
        backgroundColor: 'rgba(229, 57, 53, 0.15)',
        color: theme.palette.error.main,
        fontWeight: 500,
        fontSize: 11
    },
    resolved: {
        backgroundColor: 'rgba(76, 175, 80, 0.15)',
        color: theme.palette.success.main,
        fontWeight: 500,
        fontSize: 11
    },
    failed: {
        backgroundColor: 'rgba(229, 57, 53, 0.15)',
        color: theme.palette.error.main,
        fontWeight: 500,
        fontSize: 11
    }
}));

/**
 * StatusPill component for displaying status indicators
 * @param {string} status - 'open', 'completed', 'pending', 'running', 'active', 'resolved', or 'failed'
 */
const StatusPill = ({ status }) => {
    const classes = useStyles();

    const labels = {
        open: 'Open',
        completed: 'Completed',
        pending: 'Pending',
        running: 'Running',
        active: 'Active',
        resolved: 'Resolved',
        failed: 'Failed'
    };

    return (
        <Chip
            label={labels[status] || status}
            size="small"
            className={classes[status]}
        />
    );
};

export default StatusPill;
